import { CancelablePromise, publicIpv4 as publicIp } from "public-ip";

export function getPublicIp(): CancelablePromise<string> {
  return publicIp();
}
